import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import ReportPreviewTable from "../tables/ReportPreviewTable";
import { setSnackbar } from "../../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../../util/state/globalVariables";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";
import FinanceDialog from "../../../component/FinanceDialog";
import { useRoyaltiesPrintoutRepository } from "../../../api/repositories/RoyaltiesPrintoutRepository";
import { ArrowBackRounded, InfoRounded } from "@mui/icons-material";
import { formatDate } from "../../../utils/FormatUtils";

const ReportPreview = () => {
    const { t } = useTranslation('finance', { keyPrefix: 'royalties' });
    const { dispatchGlobalData } = useContext(GlobalContext);

    const { getPrintoutsByReportId, publishPrintouts } = useRoyaltiesPrintoutRepository();

    let { id } = useParams();

    const [data, setData] = useState<any>([]);
    const [totalElements, setTotalElements] = useState<any>(0);
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const navigate = useNavigate();

    const [updating, setUpdating] = useState(false);

    const [publishable, setPublishable] = useState<any>({});
    const [publishableLength, setPublishableLength] = useState(0);

    const onRowSelected = (id: string, isSelected: boolean, node: any) => {
        if (!isSelected) {
            delete publishable[id];
        } else {
            publishable[id] = node;
        }
    }

    useEffect(() => {
        getPrintoutsByReportId(id!)
                .then(response => {
                    let result = response.result;
                    setData(result.content);
                    setTotalElements(result.page.totalElements);
                });
    }, []);

    useEffect(() => {
        if (updating) {
            getPrintoutsByReportId(id!)
                    .then(response => {
                        let result = response.result;
                        setData(result.content);
                        setTotalElements(result.page.totalElements);
                        setUpdating(false);
                    });
        }
    }, [updating])

    const sendPrintouts = () => {
        publishPrintouts(Object.keys(publishable))
                .then(() => {
                    setUpdating(true);
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: t('preview.publish-confirmation.success-snackbar'),
                                type: snackbarTypes.success,
                                show: true,
                                autoClose: true
                            }
                        }
                    });
                })
                .finally(() => {
                    setPublishable({});
                    setPublishableLength(0);
                })
    }

    return (
            <Card variant="outlined" sx={{ margin: '15px' }}>
                <CardContent>
                    <Grid container direction={'column'} rowGap={2}>
                        <Grid item>
                            <Box style={{ display: 'flex', alignItems: 'center', gap: '1ch' }}>
                                {/*<ArrowBackRounded onClick={() => {*/}
                                {/*    navigate('/finance/royalties');*/}
                                {/*}}/>*/}
                                <Typography variant={'body1'} fontWeight={'bold'}>
                                    {t('preview.buttons.back', { reportName: data['0']?.royaltyPrintoutRequestName })}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item>
                            <ReportPreviewTable data={data} selectedDataLength={publishableLength} setSelectedDataLength={setPublishableLength}
                                                date={formatDate(data['0']?.royaltyPrintoutRequestCreationDate)}
                                                setUpdating={setUpdating}
                                                onRowSelected={onRowSelected}
                                                onPublishClick={() => setOpenConfirmationModal(true)}/>
                        </Grid>
                    </Grid>
                </CardContent>
                <FinanceDialog title={t('preview.publish-confirmation.title')}
                               content={t('preview.publish-confirmation.content', { selectedRecharges: publishableLength })}
                               open={openConfirmationModal}
                               onClose={() => setOpenConfirmationModal(false)}
                               callback={sendPrintouts}
                               cancelButton={t('preview.publish-confirmation.cancel')}
                               confirmButton={t('preview.publish-confirmation.confirm')}
                               titleIcon={<InfoRounded/>}/>
            </Card>
    );
}

export default ReportPreview;